module.exports = __webpack_public_path__ + "img/cx_a1b1a3.png";